import { SxProps, Theme } from '@mui/material';

export const fixedCellSize = (size: number, sx?: SxProps<Theme>): SxProps<Theme> => ({
  width: size,
  minWidth: size,
  maxWidth: size,
  ...sx
});
